export const stayPromotions = {
  title: "عروض الإقامة",
  description: "قدّم خصومات خاصة لنزلائك على الإقامات الطويلة",
  newPromotion: "عرض جديد",
  loading: "جارٍ تحميل العروض...",
  close: "إغلاق",
  cancel: "إلغاء",
  noLimit: "بلا حد",

  status: {
    active: "نشط",
    paused: "متوقف",
  },

  card: {
    stay: "الإقامة",
    discount: "الخصم",
    validity: "الصلاحية",
    edit: "تعديل",
    delete: "حذف",
  },

  nights: {
    range: "{min} - {max} ليلة",
    min: "{min}+ ليلة",
  },

  empty: {
    title: "لا توجد عروض مُعدّة",
    description: "أنشئ عروضًا لتشجيع الإقامات الأطول وزيادة حجوزاتك",
    create: "أنشئ أول عرض",
  },

  form: {
    editTitle: "تعديل العرض",
    createTitle: "عرض جديد",
    nameLabel: "اسم العرض",
    namePlaceholder: "مثال: خصم 7 ليالٍ، عرض الأسبوع",
    minNights: "الحد الأدنى لليالي",
    maxNights: "الحد الأقصى لليالي",
    optional: "(اختياري)",
    noLimitPlaceholder: "بلا حد",
    discountType: "نوع الخصم",
    percentage: "نسبة مئوية",
    fixedAmount: "مبلغ ثابت",
    discountValue: "قيمة الخصم",
    validFrom: "صالح من",
    validTo: "صالح حتى",
    activateNow: "تفعيل العرض فورًا",
    saving: "جارٍ الحفظ...",
    update: "تحديث",
    create: "إنشاء العرض",
  },

  invoice: {
    title: "مثال على التوفير",
    pricePerNight: "السعر لكل ليلة",
    numberOfNights: "عدد الليالي",
    subtotal: "المجموع الفرعي",
    discountApplied: "الخصم المطبَّق",
    totalToPay: "الإجمالي المستحق",
    guestSaves: "يوفّر النزيل {amount}",
  },

  statusModal: {
    activateTitle: "تفعيل العرض",
    pauseTitle: "إيقاف العرض مؤقتًا",
    activateDescription: 'هل تريد تفعيل العرض "{name}" ليُطبَّق على الحجوزات الجديدة؟',
    pauseDescription: 'هل تريد إيقاف العرض "{name}" مؤقتًا؟',
    confirm: "تأكيد",
  },

  deleteModal: {
    title: "حذف العرض",
    warningStrong: "لا يمكن التراجع عن هذا الإجراء.",
    warningText: "قبل الحذف، تأكّد من أنك لم تعد بحاجة إلى العرض {name}.",
    confirmLabel: "اكتب الاسم تمامًا للتأكيد:",
    confirmPlaceholder: "اكتب اسم العرض تمامًا",
    hint: "الصق أو اكتب الاسم كما يظهر أعلاه لتفعيل زر الحذف.",
    deleting: "جارٍ الحذف...",
    confirmDelete: "حذف نهائي",
  },

  toasts: {
    nameRequired: "يرجى إدخال اسم",
    minNightsWarning: "الحد الأدنى لليالي 1 أو أكثر",
    selectRatePlan: "اختر خطة أسعار أساسية",
    updated: "تم تحديث العرض",
    created: "تم إنشاء العرض",
    saveFailed: "تعذّر الحفظ",
    saveError: "خطأ أثناء الحفظ",
    activated: "تم تفعيل العرض",
    pausedToast: "تم إيقاف العرض مؤقتًا",
    updateFailed: "تعذّر التحديث",
    statusError: "خطأ أثناء تغيير الحالة",
    deleted: "تم حذف العرض",
    deleteFailed: "تعذّر الحذف",
    deleteError: "خطأ أثناء الحذف",
  },
};
